export default {"src":"/_next/static/media/dart.ee3b2b6d.svg","height":256,"width":256,"blurWidth":0,"blurHeight":0};